import Vue from 'vue';
import LoadingComponent from '@/components/loading/index.vue';
import i18n from '@/i18n';

// 创建loading构造函数
const LoadingConstructor = Vue.extend(LoadingComponent);

// 单例模式
let loadingInstance = null;

const Loading = {
  // 显示loading
  show(text) {
    if (!loadingInstance) {
      loadingInstance = new LoadingConstructor({
        el: document.createElement('div')
      });
      document.body.appendChild(loadingInstance.$el);
    }
    loadingInstance.show(text);
    return loadingInstance;
  },
  
  // 隐藏loading
  hide() {
    if (loadingInstance) {
      loadingInstance.hide();
    }
  },
  
  // 创建初始加载动画
  createInitialLoader() {
    // 创建一个简单的加载动画元素
    const loaderDiv = document.createElement('div');
    loaderDiv.id = 'initial-loader';
    loaderDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      z-index: 10000;
    `;
    
    // 创建加载动画
    const spinner = document.createElement('div');
    spinner.style.cssText = `
      width: 60px;
      height: 60px;
      border: 6px solid #f3f3f3;
      border-top: 6px solid #3498db;
      border-radius: 50%;
      animation: spin 1.2s linear infinite;
    `;
    
    // 创建加载文本
    const text = document.createElement('div');
    text.textContent = i18n.t('common.loading');
    text.style.cssText = `
      margin-top: 20px;
      font-size: 18px;
      font-weight: bold;
      color: #333;
    `;
    
    // 添加动画样式
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    
    // 将元素添加到DOM
    document.head.appendChild(style);
    loaderDiv.appendChild(spinner);
    loaderDiv.appendChild(text);
    document.body.appendChild(loaderDiv);
    
    // 返回加载动画元素，以便后续移除
    return loaderDiv;
  },
  
  // 移除初始加载动画
  removeInitialLoader(loader) {
    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader);
    } else {
      const existingLoader = document.getElementById('initial-loader');
      if (existingLoader) {
        existingLoader.parentNode.removeChild(existingLoader);
      }
    }
  }
};

export default Loading;
